export function yoastBreadcrumb() {
    let breadcrumb = document.querySelector('.breadcrumb_last');

    if (!breadcrumb){
        return false;
    }

    breadcrumb.classList.add('truncate')
}